import { FORM_ADVANCED, FORM_CONFIG } from './FormTemplates'

export const FORM_LAYOUT = FORM_CONFIG
export const ADVANCED_TAB = FORM_ADVANCED
